var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-banner',{staticClass:"banner1",style:({ backgroundImage: `url(${_vm.image})`}),attrs:{"elevation":"10","icon":"Vuetify"}},[_c('v-row',[_c('v-col',{staticClass:"d-flex justify-center",attrs:{"cols":"12","lg":"12"}},[_c('p',{staticClass:"d-flex justify-center",staticStyle:{"font-size":"3.5rem"}},[_c('b',[_vm._v(_vm._s(_vm.title))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }